<template>
  <div class="home-page">
    <div class="player-area-wrap" v-if="carouselList?.length">
      <player-area :playerAreaData="carouselList" ref="playerAreaRef"/>
    </div>
    <div class="live-list-wrap" v-if="liveList">
      <live-list :liveListData="liveList.data" :firstHasMore="liveList.hasMore" @pausePlayer="onPausePlayer"/>
    </div>
    <back-top/>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, onMounted, nextTick } from 'vue';
import { useStore } from 'vuex';
import PlayerArea from './components/player-area.vue';
import BackTop from '@/components/back-top.vue';
import { useServerPrefetch } from '@/composables/use-server-prefetch';
import homeService from '@/service/home';
import LiveList from './components/live-list/live-list.vue';


const store = useStore();
const playerAreaRef = ref();
const liveList = computed(() => store.state?.home?.liveList);
const carouselList = computed(() => store.state?.home?.carouselList || []);

useServerPrefetch(
  async() => {
    try{
      const { data } = await homeService.getLiveIndex(); 
      const { carousel_list, live_list, has_more } = data;
      store.state.home.carouselList = carousel_list || [];
      store.state.home.liveList = {
        data: live_list || [],
        hasMore: has_more,
      };
    }catch(e){
      console.log('**error(homeService.getLiveIndex):',e);
    }
    
  },
  store.state.home.carouselList
);

const onPausePlayer = () => {
  playerAreaRef.value?.player?.pause();
};

onMounted(async() => {
  await nextTick();
  if(document.documentElement.scrollTop){
    document.documentElement.scrollTop = 0;
  }
});
</script>

<style lang="less" scoped>
.home-page {
  background-color: #f9f9f9;

  .player-area-wrap {
    //
  }

  .live-list-wrap {
    margin-top: 60px;
  }
}
</style>
